<div *ngIf="isLoading" class="loading-overlay">
  <p-progressSpinner></p-progressSpinner>
</div>
<div class="mt-1 " >
  <div class="grid">
    <div class="col-12 p-fluid formgrid">
      <form [formGroup]="form">
        <div class="col">
          <label class="col-4">{{'WarehouseCalendar.CopyCalendar.FromFacility'  | translate }}</label>
          <div class="col">
            <laas-facility-dropdown
              [isSingle]="true"
              formControlName="fromFacility">
              (onOptionDataChange)="optionsDataOnChange($event, 'fromFacility')">
            </laas-facility-dropdown>
          </div>
        </div>
        <div class="col">
          <label class="col-4">{{ 'WarehouseCalendar.CopyCalendar.Year' | translate }}</label>
          <div class="col">
            <p-dropdown  appendTo="body"  [(ngModel)]="copyParams.year" [options]="yearList" [ngModelOptions]="{standalone: true}"></p-dropdown>
          </div>
        </div>
        <div class="col grid">
          <div class="col-4">
            <label >{{ 'WarehouseCalendar.CopyCalendar.CalendarCategory' | translate }}</label>
          </div>
          <div class="col">
            <p-radioButton formControlName="toCategory" name="toCategory" value="LAAS" label="LAAS" [(ngModel)]="copyParams.toCategory"></p-radioButton>
            <p-radioButton formControlName="toCategory" name="toCategory" value="WMS" label="WMS" [(ngModel)]="copyParams.toCategory" class="ml-2"></p-radioButton>
          </div>
        </div>
        <div class="col">
          <label  class="col-4">{{ 'WarehouseCalendar.CopyCalendar.ToFacility' | translate }}</label>
          <div class="col">
            <laas-facility-dropdown
              formControlName="toFacilityList"
              [isMultiple]="true"
              [showFilter]="true"
              [showToggleAll]="true"
              (onOptionDataChange)="optionsDataOnChange($event, 'toFacilityList')">
            </laas-facility-dropdown>
          </div>
        </div>
      </form>
    </div>
    <div class="ml-2 mt-1">
      <div class="col text-center">
        <button pRipple pButton label="{{ 'WarehouseCalendar.CopyCalendar.Copy' | translate }}" (click)="saveBtnClick($event)"></button>
      </div>
    </div>
  </div>
</div>

